angular.module('vastdesk').component('forecastBudgetFields', {
  bindings: {
    formName: '@',
    formId: '@',
    budget: '=',
    onRemoveBudget: '&',
  },
  template: require('../templates/forecastBudgetFields.html'),
  controllerAs: '$forecastBudgetFieldsCtrl',
  controller: ['$element', function ($element) {
    const self = this;

    this.availableMetrics = [
        ['revenue', 'Revenue'],
        ['requests', 'Requests'],
        ['impressions', 'Imps'],
    ];
    this.availablePeriods = [
        ['day', 'Day'],
        ['week', 'Week'],
        ['month', 'Month'],
        ['lifetime', 'Life'],
    ];
    this.availablePacing = [
        ['smooth', 'Even'],
        ['front_loaded', 'Front-Loaded'],
    ];

    const cleanNumber = (value) => {
      if (value == null || value === '') return '';

      return String(value).replace(/\D/g, '').replace(/^0+/, '');
    };

    const setupBudgetValueFormatting = () => {
      const budgetMetric = self.budget && self.budget.budget_metric;
      const budgetValue = $element.find('input[id*=budget_value]').val();

      // Add commas if type is Revenue
      const allowDelimiter = budgetMetric === 'revenue';

      const clearValue = cleanNumber(budgetValue);
      if (!clearValue) {
        $element.find('input[id*=budget_value]').val('');
        return;
      }

      const formatted = allowDelimiter
          ? clearValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
          : clearValue;

      $element.find('input[id*=budget_value]').val(formatted);
    };

    this.hasId = function () {
      return typeof self.budget.id !== "undefined" && self.budget.id !== null;
    };

    this.removeBudget = function () {
      if (self.onRemoveBudget) {
        self.onRemoveBudget();
      }
    };

    $element.on('input change', 'input[id*=budget_value]', function() {
      setupBudgetValueFormatting();
    });


    $element.on('change', 'input[id*=budget_metric]', function() {
      setupBudgetValueFormatting();
    });

    this.$onInit = function() {
      setTimeout(() => {
        setupBudgetValueFormatting();
      }, 0);
    };
  }]
});
